import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingPane, formElements } from '../../../common';
import { tenantHelpers } from '../../../tenantInfo';
import { ProgramList } from '../program-list-folder';
import './touchpoint-list.scss';

export class TouchpointEdit extends Component {

  render() {
    const { id, siteId, name, elements, rules, show, isUnsupported, onOpen, onClose, programListProps, permissionProps, aliasProps } = this.props;
    const { err } = programListProps || {};
    const { permissions } = permissionProps || {};
    const { err: permissionsErr } = permissions || {};
    const { isFetching: settingsFetching, isSubmitting: settingsSubmitting, err: settingsErr, updateAlias, response, defaultValue } = aliasProps || { isFetching: false };
    const uniqueId = siteId + '-' + id;

    const permissionsDisplay = (
      <div className={"touchpoint-section" + (isUnsupported ? " unsupported-form" : "")}>
        <LoadingPane id='alias' isLoading={settingsFetching} err={settingsErr} loadingMessage="Loading Touchpoint Alias...">
          <formElements.SimpleTextElement
            id={siteId + '-' + id + '-alias'}
            label="Alias"
            onChange={value => updateAlias(siteId, id, value)}
            response={response}
            defaultValue={defaultValue}
            disabled={settingsSubmitting}
            maxLength={100} />
        </LoadingPane>
        <br />
        <ProgramList {...programListProps} isUnsupported={isUnsupported} siteId={siteId} formId={id} permissionProps={permissionProps} err={err || permissionsErr} loadingMessage={"Loading Program Permissions..."} />
      </div>
    );

    return (
      <div className={"touchpoint-edit " + (isUnsupported ? "alert-danger" : "")}>
        <span>
          <button
            aria-describedby={uniqueId}
            aria-label={show ? 'collapse' : 'expand'}
            className={isUnsupported ? 'btn alert-danger' : 'btn'}
            onClick={show ? e => onClose() : e => onOpen()}>
            <span className={show ? 'glyphicon glyphicon-minus' : 'glyphicon glyphicon-plus'} />
          </button>
          <div id={uniqueId} className="touchpoint-label">{name}</div>
        </span>
        {show ? isUnsupported ? (
          <div id="error" role="alert" aria-live="assertive">
            {elements && elements.some(element => element.isUnsupported && element.isRequired && !element.disabled) ? (
              <div>
                TouchPoint {name} cannot be used in {tenantHelpers.getProductName()}. It includes TouchPoint elements that may display personally identifiable information or other sensitive information:
            <ul role="presentation">
                  {elements && elements.map(element => {
                    if (element.isUnsupported && element.isRequired && !element.disabled)
                      return <li role="presentation" key={element.id}>{element.typeLabel} : {element.label}{element.reason ? <span> ({element.reason})</span> : null}</li>;
                    else
                      return null;
                  })}
                </ul>
              </div>
            ) : null}

            {rules && rules.map((rule, index) => {
              if (rule.isUnsupported && !rule.disabled) {

                return (
                  <div>
                    The conditional rule "{rule.name}" is not supported in {tenantHelpers.getProductName()}:
                    <ul role="presentation">
                      {rule.reasons && rule.reasons.map((reason, index) => {
                        return <li role="presentation" key={index}>{reason ? <span> {reason}</span> : null}</li>
                      })}
                    </ul>
                  </div>);
              }
              else
                return null;
            })}
            {permissionsDisplay}
          </div>) : permissionsDisplay : null}
      </div>
    );
  }
}

TouchpointEdit.propTypes = {
  id: PropTypes.string,
  siteId: PropTypes.string,
  name: PropTypes.string,
  elements: PropTypes.array,
  show: PropTypes.bool,
  isUnsupported: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  aliasProps: PropTypes.shape({
    isFetching: PropTypes.bool,
    err: PropTypes.object,
    isSubmitting: PropTypes.bool,
    response: PropTypes.string,
    defaultValue: PropTypes.string,
    updateAlias: PropTypes.func,
  }),
  programListProps: PropTypes.shape({
    isFetching: PropTypes.bool,
    err: PropTypes.object,
    programs: PropTypes.object,
    sortBy: PropTypes.string,
    sortAsc: PropTypes.bool,
    resultsPerPage: PropTypes.number,
    changeSort: PropTypes.func,
    changePageNumber: PropTypes.func,
  }),
  permissionProps: PropTypes.shape({
    permissions: PropTypes.object,
    submission: PropTypes.object,
    responses: PropTypes.object,
  })
};

export default TouchpointEdit;
